import { useEffect } from "react";

/**
 * Hook to close when clicking outside of refs.
 * @param {boolean} isActive
 * @param {React.RefObject} buttonRef
 * @param {React.RefObject} menuRef
 * @param {() => void} onClose
 */
export const useClickOutside = (isActive, buttonRef, menuRef, onClose) => {
  useEffect(() => {
    if (!isActive) return;

    const handleClick = (e) => {
      const outsideButton = !buttonRef?.current?.contains(e.target);
      const outsideMenu = !menuRef?.current?.contains(e.target);
      const insideMuiPopper = !!e.target.closest(
        ".MuiPickersPopper-root, .MuiPickersLayout-root, .MuiDialog-root"
      );
      const insideCalendarPopup = !!e.target.closest("[data-calendar-popup]");
      if (outsideButton && outsideMenu && !insideMuiPopper && !insideCalendarPopup) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isActive, buttonRef, menuRef, onClose]);
};
